import DirectForm from 'components/form/DirectForm/DirectForm';

export default DirectForm;
